import { h } from 'preact'
import { tagParser, safeHtml } from '../../js/modules/utilities'
import fibres from './fibres.svg'
import { attributesAnalytics } from '../../js/modules/component'

export const TuileAiguillage = ({ title, backgroundColor = '', CTA: { analytics, URL, label } }) => {
   const hasBackgroundColor = backgroundColor && backgroundColor.trim() !== ''

   if (!hasBackgroundColor) {
      document.documentElement.style.setProperty('--img-fibres-aiguillage', `url(${fibres})`)
   }

   const styleOverride = hasBackgroundColor
      ? {
           backgroundColor: backgroundColor,
           backgroundImage: 'none',
        }
      : {}

   return (
      <a href={URL} class="tuile-aiguillage lien-composite" style={styleOverride} {...attributesAnalytics(analytics)}>
         <h3 class="h4 title m-0 p-0">
            <span dangerouslySetInnerHTML={{ __html: safeHtml(tagParser(title)) }} />
         </h3>
         <span class="btn btn-primary btn-inverse">{label}</span>
      </a>
   )
}
